/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DmsUrlResponseDto interface.
 */
export function instanceOfDmsUrlResponseDto(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
export function DmsUrlResponseDtoFromJSON(json) {
    return DmsUrlResponseDtoFromJSONTyped(json, false);
}
export function DmsUrlResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
        'accessToken': json['accessToken'] == null ? undefined : json['accessToken'],
    };
}
export function DmsUrlResponseDtoToJSON(json) {
    return DmsUrlResponseDtoToJSONTyped(json, false);
}
export function DmsUrlResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'accessToken': value['accessToken'],
    };
}
